import {
    Box,
    Chip,
    CircularProgress,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    type SelectProps,
    type SxProps,
    Typography
} from '@mui/material';
import { DriveEta as DriveIcon } from '@mui/icons-material';
import React from 'react';
import { apiCategoriesPublic } from '@/modules/categories/services/category.service';

type Props = {
    formSx?: SxProps;
} & SelectProps<string[]>

const DRIVING_CATEGORIES: Record<string, { name: string, description: string }> = {
    A: {
        name: 'Категория A', description: 'Мотоциклы, мотороллеры'
    },
    B: {
        name: 'Категория B', description: 'Легковые автомобили'
    },
    C: {
        name: 'Категория C', description: 'Грузовые автомобили'
    },
    D: {
        name: 'Категория D', description: 'Автобусы'
    }
};

export function CategoriesSelect({formSx, ...props}: Props) {
    const {data, isLoading} = apiCategoriesPublic();

    return (
        <FormControl
            fullWidth
            sx={formSx}
        >
            <InputLabel>
                Категории обучения
            </InputLabel>
            <Select
                label={'Категории обучения'}
                renderValue={(selected) => (
                    <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 0.5}}>
                        {selected.map((value) => (
                            <Chip
                                key={value}
                                label={value}
                                size="small"
                                sx={{
                                    backgroundColor: '#e3f2fd',
                                    color: '#1976d2',
                                    fontWeight: 'bold'
                                }}
                            />
                        ))}
                    </Box>
                )}
                startAdornment={<DriveIcon sx={{color: '#6c757d', mr: 1}}/>}
                sx={{
                    bgcolor: '#f8f9fa',
                    '& .MuiSelect-select': {
                        display: 'flex',
                        alignItems: 'center'
                    },
                    border: 'none'
                }}
                {...props}
            >
                {isLoading && <CircularProgress/>}
                {!data && !isLoading && (
                    <Typography variant={'subtitle2'}>
                        Нет данных
                    </Typography>
                )}
                {data && data.items.map((category) => {
                    const element = DRIVING_CATEGORIES[category.id];
                    if (element) {
                        return (
                            <MenuItem
                                key={category.id}
                                value={category.id}
                            >
                                <Box>
                                    <Typography
                                        variant="body2"
                                        sx={{fontWeight: 'bold'}}
                                    >
                                        {element.name}
                                    </Typography>
                                    <Typography
                                        variant="caption"
                                        sx={{color: '#6c757d'}}
                                    >
                                        {element.description}
                                    </Typography>
                                </Box>
                            </MenuItem>
                        );
                    }
                    return (
                        <MenuItem
                            key={category.id}
                            value={category.id}
                        >
                            <Box>
                                <Typography
                                    variant="body2"
                                    sx={{fontWeight: 'bold'}}
                                >
                                    {`Категория ${category.id}`}
                                </Typography>
                            </Box>
                        </MenuItem>
                    );
                })}
            </Select>
        </FormControl>
    );
}